<template>
  <Section>
    <Container>
      <FadeIn>
        <div class="rounded-[20px] md:rounded-[35px] border-2 border-[#8293f8] bg-[#c0c7fa] p-4 md:p-8 lg:p-12 mb-8 md:mb-12 lg:mb-16">
          <div class="flex flex-col md:flex-row md:gap-4 lg:gap-12">
            <div class="order-2 md:order-1 md:w-[50%] lg:w-[50%]">
              <h2 class="text-section-title">
                Hearing What Matters
              </h2>
              <div
              class="text-sm sm:text-base lg:leading-[1.75rem] mt-4 lg:mt-8 prose prose-trust max-w-[400px]">
                <p>The Elker LinkedIn newsletter. A monthly briefing for Australian leaders on speak-up, risk, culture, and compliance. Issue 1 now out!</p>
              </div>
              <div 
              class="mt-4 lg:mt-8">
                <ElementButton
                url="https://www.linkedin.com/pulse/why-your-ai-rollout-needs-psychosocial-check-elkerofficial-r1gzf/"
                type="black"
                :arrow="true"
                class="inline-block "
                target="_blank"
                >
                  View Issue 1
                </ElementButton>
              </div>
            </div>
            <div class="order-1 md:order-2 md:w-[50%] mb-6 md:mb-0 lg:w-[50%] md:flex md:justify-center md:items-center">
              <a 
              href="https://www.linkedin.com/pulse/why-your-ai-rollout-needs-psychosocial-check-elkerofficial-r1gzf/"
              target="_blank"
              >
                <img
                :src="useCdn('c6ac0dd1-5e48-4b82-b3ee-0d17b97798f8', 'hearing-what-matters-1.png')"
                alt="LinkedIn newsletter: Hearing What Matters issue 1"
                class="h-auto w-full inline-block mr-6 lg:mr-12 rounded-lg"
                loading="lazy"
                width="227"
                height="102"
                >
              </a>
            </div>
          </div>
        </div>
      </FadeIn>
    </Container>
  </Section>
</template>

<script setup>
const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})
</script>